module.exports = __webpack_public_path__ + "img/pi-4-6.ec7c1446.jpg";